import { STRINGS } from '../../../constants';
import { Error } from '../../../features/ErrorBoundary';
import { WE_HAVE_A_LITTLE_PROBLEM } from '../../../features/ErrorBoundary/constants';

const LabelExpiredError = () => (
  <Error
    title={WE_HAVE_A_LITTLE_PROBLEM}
    descriptionArray={[STRINGS.EXPIRED_LABEL_ERROR]}
  />
);

export default LabelExpiredError;
